import requestInstance from "./requestInstance";

export const getStats = async () => {
  const response = await requestInstance.get("/api/v1/stats/get-overall-stats");
  return response.data;
};
